import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
type AgreementKey = 'requirements' | 'liability' | 'insurance' | 'cancel';
interface BookingAgreementsProps {
  onConfirm: () => void;
}
export function BookingAgreements({
  onConfirm
}: BookingAgreementsProps) {
  const {
    t
  } = useLanguage();
  const b = t.booking;
  const [checked, setChecked] = useState<Record<AgreementKey, boolean>>({
    requirements: false,
    liability: false,
    insurance: false,
    cancel: false
  });
  const [showError, setShowError] = useState(false);
  const items: {
    key: AgreementKey;
    text: string;
  }[] = [{
    key: 'requirements',
    text: b.requirements
  }, {
    key: 'liability',
    text: b.agreeLiability
  }, {
    key: 'insurance',
    text: b.agreeInsurance
  }, {
    key: 'cancel',
    text: b.agreeCancel
  }];
  const allChecked = items.every(item => checked[item.key]);
  function handleContinue() {
    if (!allChecked) {
      setShowError(true);
      return;
    }
    onConfirm();
  }
  return <div className="px-6 py-8 sm:px-10" data-id="element-6" data-mp="1dcqc3yuhnate">
      <h3 className="font-serif text-2xl font-bold text-bark" data-id="element-7" data-mp="1hfd4c0v2mxr4">{b.agreeTitle}</h3>
      <p className="mt-1.5 leading-relaxed text-bark/75" data-id="element-8" data-mp="1mept4r5i6ewc">{b.agreeIntro}</p>

      <fieldset className="mt-6 space-y-4" data-id="element-9" data-mp="1mdeokp48h346">
        <legend className="sr-only" data-id="element-10" data-mp="1r6zq2r51cf84">{b.agreeTitle}</legend>
        {items.map(item => <label key={item.key} htmlFor={`agree-${item.key}`} className="flex cursor-pointer items-start gap-3 rounded-lg border border-line bg-linen/60 p-4 text-[15px] leading-snug text-bark" data-id="element-11" data-mp="1w5u6xnjfztpl">
            <input id={`agree-${item.key}`} type="checkbox" checked={checked[item.key]} onChange={() => {
          setChecked(prev => ({
            ...prev,
            [item.key]: !prev[item.key]
          }));
          setShowError(false);
        }} className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer accent-saddle" data-id="element-12" data-mp="256ip8ufvcg8a" />
            <span data-id="element-13" data-mp="1j1yp6dkdjeyf">{item.text}</span>
          </label>)}
      </fieldset>

      {showError && <p role="alert" className="mt-4 text-sm font-medium text-rust" data-id="element-14" data-mp="1e4gccc38kfl5">
          {b.mustAgree}
        </p>}

      <button type="button" onClick={handleContinue} aria-disabled={!allChecked} className={`mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3.5 font-bold transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-hay sm:w-auto ${allChecked ? 'bg-saddle text-cream hover:bg-leather' : 'bg-line text-bark/60'}`} data-id="element-15" data-mp="1s00lift5xjfd">
        {b.continue}
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-16" data-mp="26scall8gefk1" />
      </button>
    </div>;
}